import FormattedMessage from 'I18n/components/FormattedMessage';
import { useEffect } from 'react';
import { PurchaseMotionCTA } from 'purchase-motions-components/components/PurchaseMotionCTA/PurchaseMotionCTA';
import { track } from '../../_core/common/eventTracking/tracker';
import getUpgradeBannerTranslations from '../../_core/utils/getUpgradeBannerTranslations';
import { getUpgradeConfigTrackingProperties, updateViewedUpgradePointsCache } from '../utils';
import BuiltOnHubSpotBadge from './BuiltOnHubSpotBadge';
import DefaultBanner from './DefaultBanner';
import { getTrackingDataFromUpgradeConfig } from '../../_core/utils/getTrackingDataFromUpgradeConfig';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const RemoveBrandingBanner = ({
  upgradePoint,
  'data-test-id': dataTestId = 'remove-branding-banner'
}) => {
  useEffect(() => {
    updateViewedUpgradePointsCache(upgradePoint.upgradeKey, () => {
      track('interaction', Object.assign({
        action: 'viewed upgrade point'
      }, getUpgradeConfigTrackingProperties(upgradePoint)));
    });
  }, [upgradePoint]);
  const {
    bannerTitle,
    bannerSubtitle
  } = getUpgradeBannerTranslations(upgradePoint.content);
  return /*#__PURE__*/_jsx(DefaultBanner, {
    dataTestId: dataTestId,
    icon: /*#__PURE__*/_jsx(BuiltOnHubSpotBadge, {}),
    titleText: /*#__PURE__*/_jsx(_Fragment, {
      children: bannerTitle
    }),
    subtext: /*#__PURE__*/_jsx(_Fragment, {
      children: bannerSubtitle
    }),
    button: /*#__PURE__*/_jsx(PurchaseMotionCTA, {
      "data-test-id": "remove-branding-pricing-page-redirect-button",
      purchaseMotion: "PRICING_PAGE_REDIRECT",
      apiName: upgradePoint.bestFitApiNameForPurchase
      //@ts-expect-error PurchaseMotionCTA uses upgrade-management-service-types upgradeConfig type
      ,
      upgradeConfig: upgradePoint,
      trackingData: getTrackingDataFromUpgradeConfig(upgradePoint),
      uiButtonProps: {
        use: 'secondary',
        size: 'extra-small',
        truncate: false
      },
      ctaProps: {
        redirectDestination: 'upgradePage'
      },
      isUpgradePoint: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.upgradeButton.default"
      })
    })
  });
};
export default RemoveBrandingBanner;